import React from 'react';
import Page from '../src/hocs/defaultPage';
import Error from '../src/containers/Error';

export default Page(() => <Error statusCode={404} />);
